import { greyTheme } from "./greyTheme";
import { Colors, mergeThemes } from '@brg/ui';

const blueTheme = mergeThemes(greyTheme, {
    themeName: 'blueTheme',
    app: {
        ...greyTheme.app,
        backgroundColor: Colors.creativeBlack,
    },
    panel: {
        title: Colors.galBlack100,
        button: {
            bg: Colors.geoWhite100,
        }
    },
    navigationBar: {
        ...greyTheme.navigationBar,
        mainNavbarColor: Colors.creativeBlack,
        backgroundColor: Colors.creativeBlack,
        borderBottomColor: Colors.creativeBlack10,
        backgroundScrollingColor: Colors.creativeBlack10,
        backgroundDirtyColor: Colors.creativeAccent,
        btns: {
            ...greyTheme.navigationBar.btns,
            changeLang: {
                ...greyTheme.navigationBar.btns.changeLang,
                background: Colors.creativeBlack10,
            },
            create: {
                ...greyTheme.navigationBar.btns.create,
                bg: Colors.creativeAccent,
                color: Colors.white,
                border: `1px solid ${Colors.creativeAccent}`,
            },
            filled: {
                ...greyTheme.navigationBar.btns.filled,
                background: {
                    ...greyTheme.navigationBar.btns.filled.background,
                    main: Colors.creativeAccent,
                    hover: Colors.creativeAccent,
                },
                text: {
                    ...greyTheme.navigationBar.btns.filled.text,
                    main: Colors.white,
                },
            },
            hollow: {
                ...greyTheme.navigationBar.btns.hollow,
                text: {
                    ...greyTheme.navigationBar.btns.hollow.text,
                    main: Colors.white,
                },
            },
        },
        login: {
            ...greyTheme.navigationBar.login,
            dropDownBackground: Colors.creativeBlack5,
            dropDownDisabledColor: '#B6B6B5',
            dropDownHoverBackground: Colors.creativeBlack10,
            dropDownHoverColor: Colors.white,
            dropdownContentBg: Colors.creativeBlack5,
            dropDownShadowColor: Colors.creativeBlack5,
        },
        mobileMenu: {
            ...greyTheme.navigationBar.mobileMenu,
            container: {
                ...greyTheme.navigationBar.mobileMenu.container,
                bg: Colors.creativeBlack5,
            },
            search: {
                bg: Colors.creativeBlack5,
            }
        }
    },
    projectEdit: {
        ...greyTheme.projectEdit,
        presentation: {
            ...greyTheme.projectEdit.presentation,
            input: {
                bg: '#213047;',
                dropdwonHover: '#2A3F5F'
            }
        }
    },
    teamMeta: {
        color: Colors.galBlack47,
        hover: Colors.galBlack73
    },
    fixedFooter: {
        ...greyTheme.fixedFooter,
        background: {
            color: Colors.creativeBlack5
        },
    },
    mainDropdownStyles: {
        ...greyTheme.mainDropdownStyles,
        bg: Colors.creativeBlack5,
        hoverBG: Colors.creativeBlack10,
    },
    hoverModal: {
        ...greyTheme.hoverModal,
        bg: {
            color: Colors.creativeBlack5,
        },
        scroll: {
            bg: Colors.creativeBlack10,
        },
    },
    //todo все попапы к одной теме
    cookies: {
        ...greyTheme.cookies,
        bg: Colors.creativeBlack5,
    },
    selectContextModal: {
        ...greyTheme.selectContextModal,
        background: Colors.creativeBlack,
        opacityTop: `linear-gradient(to top, rgba(16, 32, 48, 0), rgba(16, 32, 48, 0.6) 12.39%, ${Colors.creativeBlack})`,
        opacityBottom:
            `linear-gradient(to bottom, rgba(16, 32, 48, 0), rgba(16, 32, 48, 0.6) 12.39%, ${Colors.creativeBlack})`,
    },
    modal: {
        ...greyTheme.modal,
        solidBackgroundColor: Colors.creativeBlack,
        backgroundColor: Colors.creativeBlack,
    },
    mainSearchBar: {
        ...greyTheme.mainSearchBar,
        bg: Colors.creativeBlack5,
        input: {
            ...greyTheme.mainSearchBar.input,
            bg: Colors.creativeBlack5,
        },
    },
    designerPage: {
        ...greyTheme.designerPage,
        slideItemBg: Colors.creativeAccent,

    },
    tags: {
        ...greyTheme.tags,
        cloud: {
            ...greyTheme.tags.cloud,
            background: Colors.creativeBlack5,
        },
    },
    table: {
        border: Colors.creativeBlack20,
        headerBg: Colors.creativeBlack5,
        text: Colors.white,
        icon: {
            default: Colors.geoWhite47,
            active: Colors.geoWhite73,
        },
    },
    competition: {
        bg: Colors.creativeBlack,
    },
    teamConstructor: {
        bg: Colors.geoWhite100,
        description: {
            bg: Colors.galBlack100,
            color: Colors.geoWhite100,
        },
        smallText: {
            color: Colors.galBlack100,
        },
        fields: {
            bg: Colors.galBlack5,
        }
    },
    buttons: {
        filled: {
            bg: {
                default: Colors.creativeAccent,
                hover: Colors.creativeAccentHover,
            },
            color: {
                default: Colors.white,
            },
        },
    },
});



export default blueTheme;import { greyTheme } from "./greyTheme";
import { Colors, mergeThemes } from '@brg/ui';

const blueTheme = mergeThemes(greyTheme, {
    themeName: 'blueTheme',
    app: {
        ...greyTheme.app,
        backgroundColor: Colors.creativeBlack,
    },
    panel: {
        title: Colors.galBlack100,
        button: {
            bg: Colors.geoWhite100,
        }
    },
    navigationBar: {
        ...greyTheme.navigationBar,
        mainNavbarColor: Colors.creativeBlack,
        backgroundColor: Colors.creativeBlack,
        borderBottomColor: Colors.creativeBlack10,
        backgroundScrollingColor: Colors.creativeBlack10,
        backgroundDirtyColor: Colors.creativeAccent,
        btns: {
            ...greyTheme.navigationBar.btns,
            changeLang: {
                ...greyTheme.navigationBar.btns.changeLang,
                background: Colors.creativeBlack10,
            },
            create: {
                ...greyTheme.navigationBar.btns.create,
                bg: Colors.creativeAccent,
                color: Colors.white,
                border: `1px solid ${Colors.creativeAccent}`,
            },
            filled: {
                ...greyTheme.navigationBar.btns.filled,
                background: {
                    ...greyTheme.navigationBar.btns.filled.background,
                    main: Colors.creativeAccent,
                    hover: Colors.creativeAccent,
                },
                text: {
                    ...greyTheme.navigationBar.btns.filled.text,
                    main: Colors.white,
                },
            },
            hollow: {
                ...greyTheme.navigationBar.btns.hollow,
                text: {
                    ...greyTheme.navigationBar.btns.hollow.text,
                    main: Colors.white,
                },
            },
        },
        login: {
            ...greyTheme.navigationBar.login,
            dropDownBackground: Colors.creativeBlack5,
            dropDownDisabledColor: '#B6B6B5',
            dropDownHoverBackground: Colors.creativeBlack10,
            dropDownHoverColor: Colors.white,
            dropdownContentBg: Colors.creativeBlack5,
            dropDownShadowColor: Colors.creativeBlack5,
        },
        mobileMenu: {
            ...greyTheme.navigationBar.mobileMenu,
            container: {
                ...greyTheme.navigationBar.mobileMenu.container,
                bg: Colors.creativeBlack5,
            },
            search: {
                bg: Colors.creativeBlack5,
            }
        }
    },
    projectEdit: {
        ...greyTheme.projectEdit,
        presentation: {
            ...greyTheme.projectEdit.presentation,
            input: {
                bg: '#213047;',
                dropdwonHover: '#2A3F5F'
            }
        }
    },
    teamMeta: {
        color: Colors.galBlack47,
        hover: Colors.galBlack73
    },
    fixedFooter: {
        ...greyTheme.fixedFooter,
        background: {
            color: Colors.creativeBlack5
        },
    },
    mainDropdownStyles: {
        ...greyTheme.mainDropdownStyles,
        bg: Colors.creativeBlack5,
        hoverBG: Colors.creativeBlack10,
    },
    hoverModal: {
        ...greyTheme.hoverModal,
        bg: {
            color: Colors.creativeBlack5,
        },
        scroll: {
            bg: Colors.creativeBlack10,
        },
    },
    //todo все попапы к одной теме
    cookies: {
        ...greyTheme.cookies,
        bg: Colors.creativeBlack5,
    },
    selectContextModal: {
        ...greyTheme.selectContextModal,
        background: Colors.creativeBlack,
        opacityTop: `linear-gradient(to top, rgba(16, 32, 48, 0), rgba(16, 32, 48, 0.6) 12.39%, ${Colors.creativeBlack})`,
        opacityBottom:
            `linear-gradient(to bottom, rgba(16, 32, 48, 0), rgba(16, 32, 48, 0.6) 12.39%, ${Colors.creativeBlack})`,
    },
    modal: {
        ...greyTheme.modal,
        solidBackgroundColor: Colors.creativeBlack,
        backgroundColor: Colors.creativeBlack,
    },
    mainSearchBar: {
        ...greyTheme.mainSearchBar,
        bg: Colors.creativeBlack5,
        input: {
            ...greyTheme.mainSearchBar.input,
            bg: Colors.creativeBlack5,
        },
    },
    designerPage: {
        ...greyTheme.designerPage,
        slideItemBg: Colors.creativeAccent,

    },
    tags: {
        ...greyTheme.tags,
        cloud: {
            ...greyTheme.tags.cloud,
            background: Colors.creativeBlack5,
        },
    },
    table: {
        border: Colors.creativeBlack20,
        headerBg: Colors.creativeBlack5,
        text: Colors.white,
        icon: {
            default: Colors.geoWhite47,
            active: Colors.geoWhite73,
        },
    },
    competition: {
        bg: Colors.creativeBlack,
    },
    teamConstructor: {
        bg: Colors.geoWhite100,
        description: {
            bg: Colors.galBlack100,
            color: Colors.geoWhite100,
        },
        smallText: {
            color: Colors.galBlack100,
        },
        fields: {
            bg: Colors.galBlack5,
        }
    },
    buttons: {
        filled: {
            bg: {
                default: Colors.creativeAccent,
                hover: Colors.creativeAccentHover,
            },
            color: {
                default: Colors.white,
            },
        },
    },
});



export default blueTheme;